import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Tab, Tabs } from '@material-ui/core';
import { NavLink as RouterLink } from 'react-router-dom';

const TabView = () => {
  const [currentTab, setCurrentTab] = useState('profile');
  const location = useLocation();

  const tabs = [
    { 
      value: 'profile', 
      label: 'Profile', 
      href: '/app/settings/profile' 
    },
    {
      value: 'security',
      label: 'Security',
      href: '/app/settings/security'
    },
    {
      value: 'systemSettings',
      label: 'System Settings',
      href: '/app/settings/system-settings'
    },
    {
      value: 'audit',
      label: 'Audit',
      href: '/app/settings/audit'
    }
  ];

  useEffect(() => {
    tabs.map((tab) => {
      if (tab.href === location.pathname) {
        setCurrentTab(tab.value);
      }
    });
  }, [location]);

  const handleTabsChange = (event, value) => {
    setCurrentTab(value);
  };
  return (
    <Box>
      <Tabs
        onChange={handleTabsChange}
        scrollButtons="auto"
        value={currentTab}
        variant="scrollable"
        textColor="secondary"
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            label={tab.label}
            value={tab.value}
            component={RouterLink}
            exact
            to={tab.href}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default TabView;
